/**
 * Get color for building based on popety_classification
 * Colors are consistent with the Explore Buildings map
 */
export const getBuildingClassificationColor = (
  classification?: string
): string => {
  const colorMap: Record<string, string> = {
    Retail: '#D3B39C',
    Residential: '#F9D518',
    Public: '#8C8C8C',
    Other: '#CCCCCC',
    Offices: '#9ecae1',
    'Not classified': '#CCCCCC',
    Mixed_2: '#F3733C',
    Mixed_1: '#F3A83C',
    Industrial: '#C39EF9',
    Garage: '#bbbbbb',
  }

  return colorMap[classification || ''] || '#00ADE6' // Default to cyan if not found
}
